// extracted by css-extract-rspack-plugin
export default {"root":"src-components-PopoverShell-PopoverShell-module__root-Pc6jS1","rootFixed":"src-components-PopoverShell-PopoverShell-module__rootFixed-gRVAll","layerToolbar":"src-components-PopoverShell-PopoverShell-module__layerToolbar-UkC0il","layerSecondary":"src-components-PopoverShell-PopoverShell-module__layerSecondary-hqGPOl","layerFloating":"src-components-PopoverShell-PopoverShell-module__layerFloating-UfsK4h","body":"src-components-PopoverShell-PopoverShell-module__body-v9xhVU"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"root\":\"src-components-PopoverShell-PopoverShell-module__root-Pc6jS1\",\"rootFixed\":\"src-components-PopoverShell-PopoverShell-module__rootFixed-gRVAll\",\"layerToolbar\":\"src-components-PopoverShell-PopoverShell-module__layerToolbar-UkC0il\",\"layerSecondary\":\"src-components-PopoverShell-PopoverShell-module__layerSecondary-hqGPOl\",\"layerFloating\":\"src-components-PopoverShell-PopoverShell-module__layerFloating-UfsK4h\",\"body\":\"src-components-PopoverShell-PopoverShell-module__body-v9xhVU\"}";
        // 1793732344990
        var cssReload = require("../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  